// Stub for @magento/peregrine Price component
import React from 'react';
import { number, string } from 'prop-types';

export const Price = ({ value, currencyCode = 'EUR' }) => {
    const formatter = new Intl.NumberFormat('nl-NL', {
        style: 'currency',
        currency: currencyCode
    });
    
    return <span>{formatter.format(value)}</span>;
};

Price.propTypes = {
    value: number.isRequired,
    currencyCode: string
};

export default Price;
